export const prefersReducedMotion = () =>
  typeof window !== 'undefined' &&
  !!window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Позиция элемента в документе. Считаем по offsetTop, а не по
// getBoundingClientRect: тот возвращает координаты с учётом трансформации, а
// AOS держит ещё не показанный блок сдвинутым — прокрутка промахивалась.
const getOffsetTop = (node) => {
  let top = 0;
  let element = node;

  while (element) {
    top += element.offsetTop;
    element = element.offsetParent;
  }

  return top;
};

// У секций лендингов большие отступы сверху, поэтому ведём не к их границе,
// а к заголовку, помеченному data-anchor, вычитая высоту липкой шапки.
export const scrollToLandingSection = (id) => {
  const section = document.getElementById(id);
  if (!section) return;

  const anchor = section.querySelector('[data-anchor]') || section;
  const header = document.querySelector('[data-landing-header]');
  const headerHeight = header?.offsetHeight ?? 66;
  const top = getOffsetTop(anchor) - headerHeight - 16;

  window.scrollTo({
    top: Math.max(0, top),
    behavior: prefersReducedMotion() ? 'auto' : 'smooth',
  });
};
